import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export const MARKETPLACE: MenuItem = {
  label: ADMIN_ROUTE_CONSTANTS.marketplace.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.marketplace.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.marketplace.alliedServices.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.marketplace.alliedServices.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.marketplace.path}/${ADMIN_ROUTE_CONSTANTS.marketplace.alliedServices.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.marketplace.suppliers.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.marketplace.suppliers.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.marketplace.path}/${ADMIN_ROUTE_CONSTANTS.marketplace.suppliers.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.marketplace.quotations.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.marketplace.quotations.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.marketplace.path}/${ADMIN_ROUTE_CONSTANTS.marketplace.quotations.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.marketplace.contractsPayments.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.marketplace.contractsPayments.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.marketplace.path}/${ADMIN_ROUTE_CONSTANTS.marketplace.contractsPayments.path}`
    }
  ]
};
